import { render, staticRenderFns } from "./MyTitle.vue?vue&type=template&id=3cef3965&scoped=true"
import script from "./MyTitle.vue?vue&type=script&lang=js"
export * from "./MyTitle.vue?vue&type=script&lang=js"
import style0 from "./MyTitle.vue?vue&type=style&index=0&id=3cef3965&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cef3965",
  null
  
)

export default component.exports